<script>
import { mapActions } from 'vuex';
import snackbarMixin from '@/mixins/snackbar';
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';

export default {
  name: 'MasterDataForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
  },
  mixins: {
    snackbarMixin,
  },
  props: {
    client: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      trainings: [],
      categoriesToQuestionaries: [],
    };
  },
  created() {
    this.getCompanyQuestionnaries(this.client.id);
    this.getCompanyTrainings(this.client.id);
  },
  methods: {
    ...mapActions('clientDetails', ['fetchCompanyQuestionaryData', 'fetchCompanyTrainingData']),
    onQuestionaryChange() {
      const questionaries = this.categoriesToQuestionaries
        .map(it => ({ id: it.questionary }))
        .filter(it => it.id);
      this.$emit('questionaryChange', questionaries);
    },
    getCompanyQuestionnaries(clientId) {
      this.fetchCompanyQuestionaryData(clientId)
        .then((response) => {
          this.categoriesToQuestionaries = response.data;
          this.categoriesToQuestionaries.forEach((it) => {
            if (it.questionaries && it.questionaries.length > 0) {
              it.questionaries.push({ id: null, name: '' });
            }
          });
        })
        .catch(() => {
          this.showErrorMessage('Achtung: Die Kategorien konnten nicht geladen werden.');
        });
    },
    getCompanyTrainings(clientId) {
      this.fetchCompanyTrainingData(clientId)
        .then((response) => {
          this.trainings = response.data;
          if (this.trainings && this.trainings.length > 0) {
            this.trainings.push({ id: null, name: '' });
          }
        })
        .catch(() => {
          this.showErrorMessage('Achtung: Die Training-Daten konnten nicht geladen werden.');
        });
    },
  },
};
</script>

<template>
  <v-form>
    <v-container fluid grid-list-lg pt-2 pa-0>
      <v-layout row wrap>
        <v-flex xs12 md3 py-0>
          <v-text-field v-model="client.name" label="Bezeichnung" height="22" class="caption"/>
        </v-flex>

        <v-flex xs12 md3 py-0>
          <v-text-field
            v-model="client.shortName"
            label="Kurzbez. für Benutzername"
            height="22"
            class="caption"
          />
        </v-flex>

        <v-flex xs12 md2 py-0>
          <v-checkbox v-model="client.isActive" label="Aktiv" class="caption" hide-details/>
        </v-flex>

        <v-flex xs12 md2 py-0>
          <v-checkbox v-model="client.isDemo" label="Demo" class="caption" hide-details/>
        </v-flex>

        <v-flex xs12 md2 py-0>
          <v-text-field
            v-model="client.userCount"
            label="Max. Benutzerzahl"
            height="22"
            class="caption"
            mask="###"
          />
        </v-flex>

        <v-flex xs12 md12/>

        <v-flex xs12 md6 py-0>
          <v-text-field v-model="client.street" label="Straße" height="22" class="caption"/>
        </v-flex>

        <v-flex xs12 md3 py-0>
          <v-text-field v-model="client.zipCode" label="PLZ" height="22" class="caption"/>
        </v-flex>

        <v-flex xs12 md3 py-0>
          <v-text-field v-model="client.city" label="Stadt" height="22" class="caption"/>
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-text-field v-model="client.country" label="Land" height="22" class="caption"/>
        </v-flex>
        <v-flex xs12 md12>&nbsp;</v-flex>
        <v-flex xs12 md6 py-0>
          <v-text-field v-model="client.mobile" label="Mobil" height="22" class="caption"/>
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-text-field v-model="client.phone" label="Telefon" height="22" class="caption"/>
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-text-field v-model="client.fax" label="Fax" height="22" class="caption"/>
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-text-field v-model="client.email" label="E-Mail" height="22" class="caption"/>
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-text-field v-model="client.web" label="Website" height="22" class="caption"/>
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-select
            :items="trainings"
            v-model="client.training"
            item-value="id"
            item-text="name"
            height="22"
            label="Schulung"
          />
        </v-flex>
      </v-layout>

      <v-flex xs12 md6>
        <v-checkbox
          v-model="client.isDownloadEnabled"
          label="Download-Rechte"
          class="caption"
          hide-details
        />
      </v-flex>

      <v-flex xs12 md12 />
      <v-layout row wrap>
        <v-flex xs6 md6 py-0>
          <h4>Aktive Module</h4>
          <v-layout row wrap>
            <v-flex xs6 md6 py-0>
              <v-layout row wrap>
                <v-flex xs6 md6 py-0>
                  <div class="flex-label">
                    <label class="v-label theme--light">
                      Audits
                    </label>
                  </div>
                </v-flex>

                <v-flex xs6 md6 py-0>
                  <v-checkbox
                    v-model="client.isPrivacyAuditsEnabled"
                    label
                    class="caption"
                    hide-details
                  />
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs6 md6 py-0>
                  <div class="flex-label">
                    <label class="v-label theme--light">
                      Toms
                    </label>
                  </div>
                </v-flex>

                <v-flex xs6 md6 py-0>
                  <v-checkbox
                    v-model="client.isTomsEnabled"
                    label
                    class="caption"
                    hide-details
                  />
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs6 md6 py-0>
                  <div
                    class="flex-label">
                  <label class="v-label theme--light">Verfahren</label></div>
                </v-flex>

                <v-flex xs6 md6 py-0>
                  <v-checkbox
                    v-model="client.isProcedureDirectoriesEnabled"
                    label
                    class="caption"
                    hide-details
                  />
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs6 md6 py-0>
                  <div class="flex-label">
                    <label class="v-label theme--light">AV-Verträge</label>
                  </div>
                </v-flex>

                <v-flex xs6 md6 py-0>
                  <v-checkbox
                    v-model="client.isAvContractsEnabled"
                    label
                    class="caption"
                    hide-details
                  />
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs6 md6 py-0>
                  <div
                    class="flex-label">
                    <label class="v-label theme--light">Schulungen</label>
                  </div>
                </v-flex>

                <v-flex xs6 md6 py-0>
                  <v-checkbox
                    v-model="client.isTrainingEnabled"
                    label
                    class="caption"
                    hide-details
                  />
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs6 md6 py-0>
                  <div
                    class="flex-label">
                    <label class="v-label theme--light">Dokumente</label>
                  </div>
                </v-flex>

                <v-flex xs6 md6 py-0>
                  <v-checkbox
                    v-model="client.isSharedDocumentsEnabled"
                    label
                    class="caption"
                    hide-details
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs6 md6 py-0>
          <h4>Fragenkataloge</h4>

          <div
            v-for="categoryAndQuestionary in categoriesToQuestionaries"
            :key="categoryAndQuestionary.category.id"
          >
            <v-layout row wrap>
              <v-flex xs6 md6 py-0>
                <div class="flex-label">
                  <label class="v-label theme--light">
                    {{ categoryAndQuestionary.category.name }}
                  </label>
                </div>
              </v-flex>

              <v-flex xs6 md6 py-0>
                <v-select
                  v-model="categoryAndQuestionary.questionary"
                  :items="categoryAndQuestionary.questionaries"
                  item-value="id"
                  item-text="name"
                  height="22"
                  label=""
                  @change="onQuestionaryChange"
                />
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<style>
  div.flex-label {
    padding-top: 22px !important;
  }
</style>
